import { Button, Alert, AlertDescription } from '@design-system';
import { QuestionnaireDialog } from '@/features/client-quick-plan';

import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { SessionType } from '@shared';

import { selectMaybeClient, selectSession, selectFeatureFlags } from '@/model';
import { clientNeedsFullIntakeForm } from '@/shared/lib/utils';

export function IncompleteIntakeAlert() {
  const client = useSelector(selectMaybeClient);
  const { sessionType } = useSelector(selectSession);
  const featureFlags = useSelector(selectFeatureFlags);
  const isD2C = sessionType === SessionType.client && !!featureFlags.d2cMode;
  const isGenworthMode = !!featureFlags.genworthMode;
  const navigate = useNavigate();
  const { clientId } = useParams<{ clientId: string }>();
  const [dialogOpen, setDialogOpen] = useState(false);

  if (isD2C || !clientNeedsFullIntakeForm(client, isGenworthMode)) {
    return null;
  }

  return (
    <>
      <Alert
        variant="warning"
        className="flex! flex-col p-3"
      >
        <AlertDescription className="text-sm">
          This client was created with basic information. For personalized projections, please
          complete the medical questionnaire, or customize the assumptions yourself.
        </AlertDescription>
        <div className="mt-3 flex w-full flex-wrap items-center gap-2">
          <Button
            size="sm"
            className="h-7 rounded-sm px-2.5 text-xs"
            onClick={() => setDialogOpen(true)}
          >
            Complete Medical Questionnaire
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="text-foreground h-7 rounded-sm px-2.5 text-xs"
            onClick={() =>
              navigate(`/clients/${clientId}/onboarding/edit-assumptions?from=overview`)
            }
          >
            Set Care Assumptions
          </Button>
        </div>
      </Alert>
      <QuestionnaireDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
      />
    </>
  );
}
